// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 60868 ? "auth-suite-sdk" : chunkId) + "-" + {"38370":"7d32f9d54ca6400010da","40646":"074a2ad8756f03ddb41f","47223":"594e0ef428f720037455","54047":"49cbecf699997679a609","54651":"d05330054db1188d1c63","60868":"fa9dfaf4cbaea2031199","69126":"9dd73bdb8a24202d2577"}[chunkId] + ".min.js";
};